import script from "./payment-run-step-one.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-run-step-one.vue?vue&type=script&setup=true&lang=ts"

import "./payment-run-step-one.vue?vue&type=style&index=0&id=622a8925&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622a8925"]])

export default __exports__